import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiMenu, FiLogOut, FiUser, FiLayout } from 'react-icons/fi';
import { useAuth } from '../../hooks/useAuth';
import { logOut } from '../../services/authService';
import { LogoLockup } from '../LogoMark';
import '../../styles/navbar.css';

export const Navbar = ({ toggleSidebar, onToggleNavMode }) => {
  const { currentUser, userData } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logOut();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <button className="menu-button" onClick={toggleSidebar} aria-label="Toggle sidebar">
          <FiMenu size={20} />
        </button>
        <Link to="/dashboard" className="navbar-logo">
          <LogoLockup size={26} />
        </Link>
      </div>

      <div className="navbar-right">
        <div className="user-section">
          <FiUser size={14} />
          <span>{userData?.displayName || currentUser?.email}</span>
        </div>
        <button className="nav-mode-btn" onClick={onToggleNavMode} title="Switch to Top Navigation">
          <FiLayout size={14} />
          <span>Top Nav</span>
        </button>
        <button className="logout-button" onClick={handleLogout}>
          <FiLogOut size={14} />
          <span>Log Out</span>
        </button>
      </div>
    </nav>
  );
};
